module.exports = __webpack_public_path__ + "img/carinfor.0be2f81c.png";